/**
 * A point on the station map, in the map's own units: a disc in its category's colours with its icon;
 * larger and named when lit (asked for by the answer, tapped, or chosen in the legend), always named
 * when it is "you are here". As the old kiosk's PoiMarker.
 */
import { styleOf, YOU_ARE_HERE } from './pois';
import css from './StationMap.module.css';

export interface Poi {
  id: string;
  category: string;
  label: string;
  x: number;
  y: number;
}

/** The label's pill: wide enough for its words (≈0.62 em per character at this font). */
const pillWidth = (label: string, size: number) => Math.max(4, label.length) * size * 0.62 + size * 1.6;

export function PoiMarker({ poi, lit, dimmed, onTap }: { poi: Poi; lit: boolean; dimmed: boolean; onTap: (poi: Poi) => void }) {
  const style = styleOf(poi.category);
  const here = poi.category === YOU_ARE_HERE;
  const size = here ? 40 : lit ? 34 : 24;
  const icon = here ? 20 : lit ? 18 : 13;
  const named = here || lit;
  const font = here ? 13 : 12;
  const width = pillWidth(poi.label, font);
  const Icon = style.icon;
  return (
    <g transform={`translate(${poi.x}, ${poi.y})`} className={`${css.poi} ${dimmed ? css.dimmed : ''}`} onClick={() => onTap(poi)}>
      {lit && !here && <circle r={size * 0.9} fill={style.border} className={css.pulse} />}
      <circle r={size / 2} fill={here ? style.border : style.bg} stroke={style.border} strokeWidth={here ? 4 : lit ? 3 : 2} />
      <Icon x={-icon / 2} y={-icon / 2} width={icon} height={icon} color={style.ink} strokeWidth={2.4} />
      {named && (
        <g transform={`translate(0, ${size / 2 + font})`}>
          <rect x={-width / 2} y={-font} width={width} height={font * 2} rx={font} fill={here ? '#DC2626' : '#fff'} stroke={here ? '#B91C1C' : style.border} strokeWidth={1.5} />
          <text y={font * 0.36} textAnchor="middle" fontSize={font} fontWeight={600} fill={here ? '#fff' : style.ink}>{poi.label}</text>
        </g>
      )}
    </g>
  );
}
